import { request } from '../client';
import type { Paginated, Vehicle, VehicleDetail, VehicleFilterOptions, VehicleListQuery } from '../types';

/**
 * Одна сторінка каталогу. Розмір сторінки — стеля тарифу провайдера (20–40),
 * більше бекенд не віддасть; далі — лише курсором із `nextCursor`.
 */
export const listVehicles = (query: VehicleListQuery = {}): Promise<Paginated<Vehicle>> =>
	request<Paginated<Vehicle>>('/vehicles', { query });

/** Варіанти панелі фільтрів: марки, моделі за марками і те, що провайдер фільтрує сам. */
export const getVehicleFilters = (): Promise<VehicleFilterOptions> =>
	request<VehicleFilterOptions>('/vehicles/filters');

/**
 * Один лот. Ідентифікатор кодуємо — він приходить із даних провайдера,
 * а не з нашого коду, і не можна припускати, що він безпечний для URL.
 */
export const getVehicle = (id: string): Promise<VehicleDetail> =>
	request<VehicleDetail>(`/vehicles/${encodeURIComponent(id)}`);
